import { notifyApiUser } from '../common/apiNotification';

export const GUEST_DATA_MERGED_TOAST =
  'Your guest progress was merged into your account.';

export function notifyGuestDataMerged(): void {
  notifyApiUser(GUEST_DATA_MERGED_TOAST);
}

export function notifyGuestDataMergedIfPresent(
  mergedGuestData?: boolean,
): void {
  if (mergedGuestData) {
    notifyGuestDataMerged();
  }
}

export function consumeGuestMergedQueryParam(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);
  if (url.searchParams.get('guestMerged') !== '1') {
    return;
  }

  notifyGuestDataMerged();
  url.searchParams.delete('guestMerged');
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(window.history.state, '', next);
}
